import React from 'react'
import {getConfirmationIconDialog} from "../../../utils/utils"

function ConfirmationContent (props) {
    return(
        <div style={{ width: "310px", height:"217px"}}>
            <div className="internalCardContainer" style={{display:"flex", height:"40%", justifyContent:"center"}}>
                {getConfirmationIconDialog(props.data.success)}
            </div>
            <div className="internalCardContainer" style={{display:"flex", textAlign:"center", justifyContent:"center"}}>
                {props.data.message}
            </div>
            <div className="internalCardContainer" style={{display:"flex", justifyContent:"center"}}>
                <div 
                    className={["button", "standard", "normalText", "normalMediumSize"].join(" ")}
                    onClick={props.onClose}
                >
                    VOLTAR À TELA INICIAL
                </div>
            </div>
        </div>
    )
}

export default ConfirmationContent